import docsearch from 'docsearch.js';

const common = window.common;
const offline = common.isOffline();
const pathname =  window.location.pathname.replace(/\+/g, '%20');
const urldocument = pathname.substring(0, pathname.lastIndexOf('/')) + '/';
const filters = $('#navbar-search').data('algolia-filters');
const appId = $('#navbar-search').data('algolia-app-id');
const apiKey = $('#navbar-search').data('algolia-api-key');
const indexName = $('#navbar-search').data('algolia-index-name');

if (!offline && apiKey) {
  const search = docsearch({
    appId: appId,
    apiKey: apiKey,
    indexName: indexName,
    queryHook: function(query) {
      return query;
    },
    autocompleteOptions: {
      /* debug: true, */
      autoselect: true,
      openOnFocus: true,
    },
    handleSelected: function (input, event, suggestion, datasetNumber, context) {
      if (context.selectionMethod === 'click') {
        $('.form-control.ds-input').blur();
        const origin = common.isOffline() ? "" : window.origin;
        const href = origin + suggestion.url;
        common.loadMain(href);
      }
    },
    inputSelector: '#search input[type=text]',
    algoliaOptions: {
      hitsPerPage: 10,
      filters: (filters ? filters : "urldocument:" + urldocument + " AND format:web")
    },
  });

  function isSearchActive() {
    return ($('span.ds-dropdown-menu > div').children().length > 0);
  }

  function isSuggestionsEmpty() {
    return ($('span.ds-dropdown-menu > div').has('span.ds-suggestions').length === 0);
  }

  search.autocomplete.on('autocomplete:updated', event => {
    const active = isSearchActive();
    const empty = isSuggestionsEmpty();
    if (active) {
      $('.content-wrapper').addClass('algolia-autocomplete-active');
      $('span.ds-dropdown-menu').addClass('ds-dropdown-menu-active');
    } else {
      $('.content-wrapper').removeClass('algolia-autocomplete-active');
      $('span.ds-dropdown-menu').removeClass('ds-dropdown-menu-active');
    }
    if (empty) {
      $('span.ds-dropdown-menu').addClass('ds-dropdown-menu-empty');
    } else {
      $('span.ds-dropdown-menu').removeClass('ds-dropdown-menu-empty');
    }
  });
}
